import { publicRequest } from "../core/services";
const list = {
    contentList: (data) => publicRequest.post("/api/list/get-content-list", data),
};
export const apiList = {
    list,
};
